import { render, staticRenderFns } from "./PlayBase.vue?vue&type=template&id=298cbe93&scoped=true&"
import script from "./PlayBase.vue?vue&type=script&lang=ts&"
export * from "./PlayBase.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "298cbe93",
  null
  
)

export default component.exports